<template>
  <!-- Info Button -->
  <button class="info-btn" @click="toggleInfo">Info</button>

  <!-- Info Modal -->
  <div v-if="infoOpen" class="info-modal">
    <div id="close-info" @click="toggleInfo"></div>
    <div class="info-content">
      <h3>Spelregels</h3>
      <div class="scrollable-text">
        <p>Welkom bij de ToepApp! Dit zijn de spelregels:</p>
        <ul class="info-list">
          <li class="info-list-item">
            Het spel wordt gespeeld met de kaarten boer, vrouw, heer, aas, 7, 8,
            9 en 10.
          </li>
          <li class="info-list-item">
            Vanaf vijf spelers doet ook de 6 mee. Vanaf zeven spelers ook de 5.
          </li>
          <li class="info-list-item">
            De boer is de laagste kaart, de 10 de hoogste.
          </li>
          <li class="info-list-item">
            Het doel is om de laatste ronde te winnen. De verliezers krijgen
            strafpunten.
          </li>
          <li class="info-list-item">
            De speler die als eerste het maximaal aantal strafpunten bereikt,
            verliest het spel.
          </li>
          <li class="info-list-item">
            Als een speler "toept", verhoogt de inzet van de ronde.
          </li>
          <li>
            Je krijgt een kleine speler punt als je bij de eerste toep foldt.
            Als je zelf toept of callt, reset deze weer naar 0.
          </li>
          <li class="info-list-item">
            Als je 2 ‘kleine speler’ punten hebt, móét je mee met de volgende
            toep!
          </li>
          <li class="info-list-item">
            Wanneer iemand voor zijn dood speelt, moet iedereen aangeven of ze
            meespelen. Speel je mee? Dan speel je voor 2 strafpunten.
          </li>
          <li class="info-list-item">
            Voor de eerst gespeelde kaart, mag iedereen vuile was aangeven. Word
            je niet gecheckt? Dan krijg je nieuwe kaarten. Word je wel gecheckt?
            Dan krijg je alleen nieuwe kaarten als je maximaal één 6 en lager
            had. De mensen die je checkten krijgen dan een strafpunt. Had je
            geen vuile was? Dan krijg je geen nieuwe kaarten en het aantal
            mensen dat jou checkt aan strafpunten.
          </li>
        </ul>
      </div>
      <button class="close-info" @click="toggleInfo">Sluiten</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBlock',
  data() {
    return {
      infoOpen: false,
    }
  },
  methods: {
    toggleInfo() {
      this.infoOpen = !this.infoOpen
    },
  },
}
</script>

<style scoped>
/* Info Button */
.info-btn {
  position: absolute;
  top: 0.5rem;
  right: 9.5rem; /* placed left of scoreboard-btn */
  padding: 6px 12px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.2s ease-in-out;
  z-index: 2;
  width: 3rem;
}

.info-btn:hover {
  background: #1e7e34;
}

/* Info Modal */
.info-modal {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.info-content {
  padding: 2rem;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.71);
  max-width: 50%;
  max-height: 80%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 200;
}

.info-content h3 {
  margin-bottom: 10px;
  color: white;
}

.info-list-item {
  margin-bottom: 10px;
  color: white;
}

.scrollable-text {
  overflow-y: auto;
  width: 100%;
  color: white;
  text-align: left;
  padding-right: 1rem;
}

.scrollable-text ul {
  padding-left: 1.5rem;
}

.close-info {
  margin-top: 10px;
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}

.close-info:hover {
  background: #ff1a1a;
}

#close-info {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
